import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: 584,
    // paddingTop: 8,
  },
  text: {
    fontSize: 14,
    fontWeight: 400,
    color: '#000000',
  },
  mt_24: {
    marginTop: 24,
  },
}));
